import FilePpt from 'buyside/svgs/document/file-ppt.svg';
import FileExcel from 'buyside/svgs/document/file-excel.svg';
import FileWord from 'buyside/svgs/document/file-word.svg';
import FilePdf from 'buyside/svgs/document/file-pdf.svg';
import FilePicture from 'buyside/svgs/document/file-picture.svg';
import FilePlay from 'buyside/svgs/document/file-play.svg';
import FileText from 'buyside/svgs/document/file-text.svg';

const fileIcons = {
  ppt: FilePpt,
  pptx: FilePpt,
  pptm: FilePpt,
  ppsx: FilePpt,
  key: FilePpt,
  xls: FileExcel,
  xlsx: FileExcel,
  xlsm: FileExcel,
  csv: FileExcel,
  doc: FileWord,
  docx: FileWord,
  pdf: FilePdf,
  png: FilePicture,
  jpg: FilePicture,
  gif: FilePicture,
  mp3: FilePlay
};

export const getFilepathExtension = filepath =>
  filepath
    .split('.')
    .slice(-1)[0]
    .toLowerCase();

export const getExtensionIcon = extension => fileIcons[extension] || FileText;
